// Google Analytics 4 Event Tracking Utility

const GA_MEASUREMENT_ID = 'G-L6DJB2GK8M'

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

// Track page view
export const trackPageView = (pagePath, pageTitle) => {
  if (!isGtagAvailable()) return
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: pageTitle
  })
}

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (!isGtagAvailable()) return
  
  window.gtag('event', eventName, parameters)
}

// Predefined events for the app
export const analytics = {
  // App opened/loaded
  appOpen: () => {
    trackEvent('app_open', {
      timestamp: new Date().toISOString()
    })
  },

  // User registration
  userSignUp: (method = 'email') => {
    trackEvent('user_sign_up', {
      method: method
    })
  },

  // Successful login
  login: (method = 'email') => {
    trackEvent('login', {
      method: method
    })
  },

  // Receipt scan attempted
  receiptScanAttempt: (scanType = 'camera') => {
    trackEvent('receipt_scan_attempt', {
      scan_type: scanType // 'camera', 'upload', 'email'
    })
  },

  // Receipt/expense saved
  receiptSaved: (category = 'unknown', amount = 0) => {
    trackEvent('receipt_saved', {
      category: category,
      value: amount
    })
  },

  // Load/revenue saved
  loadSaved: (amount = 0) => {
    trackEvent('load_saved', {
      value: amount
    })
  },

  // Per diem dates entered
  perDiemEntered: (daysCount = 1) => {
    trackEvent('per_diem_entered', {
      days_count: daysCount
    })
  },

  // P&L report generated
  plReportGenerated: (reportType = 'view', dateRange = 'month') => {
    trackEvent('pl_report_generated', {
      report_type: reportType, // 'view', 'pdf', 'csv'
      date_range: dateRange
    })
  },

  // Per diem report generated
  perDiemReportGenerated: (reportType = 'view') => {
    trackEvent('per_diem_report_generated', {
      report_type: reportType
    })
  },

  // Password reset requested
  passwordResetRequested: () => {
    trackEvent('password_reset_requested')
  }
}

export default analytics
